export class ImageConsentModalController {
    public imageConsent: any = {};

    static $inject = ['dialogs', '$uibModal', '$uibModalInstance', 'applicationObservable', 'imageConsentData', 'ImageConsent'];
    constructor(private dialogs, private $uibModal, private $uibModalInstance, private applicationObservable, private imageConsentData, private ImageConsent){

    }

    submit(){
        if(!this.imageConsent.$validation()) return;
        
        this.ImageConsent.update({
             applicationId: this.imageConsentData.applicationId 
            }, this.imageConsent.imageConsent).$promise.then(() => {
                this.dialogs.notify('Public profile consent updated', 'Your public profile consent preference has been updated successfully.');
                this.applicationObservable?.refresh();
                this.$uibModalInstance.dismiss();
            }, () => {
                this.dialogs.error('Public profile consent update error', 'Unable to update. Please try again later.');
            });
    }

    close(){
        this.$uibModalInstance.dismiss();
    }
}